import React, { useContext, useEffect } from 'react';
import Sidebar from './Sidebar';
import BarraPrincipal from './BarraPrincipal';
import ContenedorFormulario from './ContenedorFormulario';
import ContenedorPrincipal from './ContenedorPrincipal';

import proyectoContext from '../../context/proyectos/proyectoContext';
import AuthContext from '../../context/autenticacion/authContext';

const Dashboard = () => {

    // Extraer funcion que calcula la altura
    const proyectosContext = useContext(proyectoContext);
    const { alturaactualcontenedor } = proyectosContext;

    // Extraer la informacion de autenticación
    const authContext = useContext(AuthContext);
    const { usuarioAutenticado } = authContext;

    useEffect(() => {
        usuarioAutenticado();
        // eslint-disable-next-line
    }, []);

    return ( 
        <div className="contenedor-app">
            <Sidebar />

            <div className="seccion-principal">
                <BarraPrincipal/>

                <main>
                    <ContenedorFormulario />

                    <div className="contenedor-principal" style={{maxHeight: alturaactualcontenedor}}>
                        <ContenedorPrincipal />
                    </div>
                </main>
            </div>
        </div>
    );
}
 
export default Dashboard;